import { render, staticRenderFns } from "./SaveDialog.vue?vue&type=template&id=6c304596&"
import script from "./SaveDialog.vue?vue&type=script&lang=ts&"
export * from "./SaveDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports